import { PlaceholderPage } from './PlaceholderPage'

export function AnalyticsPage() {
  return (
    <PlaceholderPage
      title="Studio Insights"
      description="Unified analytics tracking from social impressions to collector purchases."
      roadmapItems={[
        'Cross-platform reach & engagement tracking (IG, Pinterest, X)',
        'Conversion funnel: Social Post → Portfolio Visit → Purchase',
        'Top performing artworks & collections analysis',
        'Collector demographics and geographical insights',
        'Revenue forecasting based on engagement patterns',
      ]}
    />
  )
}

export function SocialCreatorPage() {
  return (
    <PlaceholderPage
      title="AI Social Creator"
      description="Transform your artwork into platform-optimized social content in seconds."
      roadmapItems={[
        'One-click generation: Art → IG Post, Story, & Pinterest Pin',
        'AI Artist Voice matching for on-brand captions',
        'Branded design templates (Minimal, Bold, Editorial)',
        'Automated hashtag research and rotation',
        'AI room mockup generation for social previews',
      ]}
    />
  )
}

export function SocialCalendarPage() {
  return (
    <PlaceholderPage
      title="Content Calendar"
      description="Plan and automate your social presence across all artist channels."
      roadmapItems={[
        'Drag-and-drop weekly content planning',
        'Cross-platform scheduling (Instagram, Pinterest, Twitter/X)',
        'Suggested "Weekly Focus" prompts based on portfolio patterns',
        'Behind-the-scenes studio story templates',
        'Batch content creation workflows',
      ]}
    />
  )
}

export function EmailMarketingPage() {
  return (
    <PlaceholderPage
      title="Collector Nurturing"
      description="Build and engage your direct-to-collector relationship."
      roadmapItems={[
        'Automated "New Work" announcements to your list',
        'Portfolio lead magnets and email capture optimization',
        'VIP early access campaigns for upcoming drops',
        'Automated welcome sequences for new collectors',
        'Segment-based campaigns (Existing buyers vs. Prospects)',
      ]}
    />
  )
}

export function DropsPage() {
  return (
    <PlaceholderPage
      title="Campaign Drops"
      description="Manage coordinated launches for new collections and limited editions."
      roadmapItems={[
        'Integrated launch calendar across social, email, and portfolio',
        'Countdown timers and scarcity messaging automation',
        'Waitlist management for upcoming releases',
        'Post-launch performance reporting',
        'Flash sale and limited-time offer management',
      ]}
    />
  )
}
